import {
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal'
import { Divider, SimpleGrid } from '@chakra-ui/layout'
import { Button } from '@chakra-ui/button'

import get from 'lodash/get'

import { ModalBodyAccredited } from './Fields/Accredited'

type ModalProps = {
  original: {}
  isOpen: boolean
  onClose: () => void
}

export function Modal({ original, isOpen, onClose }: ModalProps) {
  return (
    <ChakraModal isCentered isOpen={isOpen} onClose={onClose} size="3xl">
      <ModalOverlay backdropFilter="blur(10px) hue-rotate(90deg)" />
      <ModalContent marginTop={{ base: 'auto', tablet: 'auto' }} mb="auto">
        <ModalHeader>{get(original, 'name')}</ModalHeader>
        <ModalCloseButton marginTop="0.5rem" />
        <Divider height="1rem" />
        <ModalBody mb="2rem">
          <SimpleGrid
            columns={{ base: 1, tablet: 2 }}
            spacingX="1rem"
            spacingY="1rem"
          >
            <ModalBodyAccredited original={original} />
          </SimpleGrid>
        </ModalBody>
        <Divider height="1rem" />
        <ModalFooter>
          <Button onClick={onClose}>Fechar</Button>
        </ModalFooter>
      </ModalContent>
    </ChakraModal>
  )
}
